import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';

import SohoFrameworkTestKeys from '../../../../Utils/SohoFrameworkTestKeys';
import { UserCard } from '../../Components';

import styles from './Users.Styles';

function Users({
  users,
  images,
  onRemoveUserPress,
  onViewProfilePress,
  titleContainerStyle,
  titleTextStyle,
  userCardContainerStyle,
  removeUserIconStyle,
  removeUserTextStyle,
  removeUserContainerStyle,
  userIconStyle,
  withRemoveUser,
  ...props
}) {
  const renderUserCards = allUsers => {
    return _map(allUsers, user => {
      return (
        <UserCard
          {...user}
          images={images}
          containerStyle={userCardContainerStyle}
          onRemoveUserPress={() => onRemoveUserPress(user)}
          onViewProfilePress={() => onViewProfilePress(user)}
          removeUserIconStyle={removeUserIconStyle}
          removeUserTextStyle={removeUserTextStyle}
          removeUserContainerStyle={removeUserContainerStyle}
          userIconStyle={userIconStyle}
          withRemoveUser={withRemoveUser}
        />
      );
    });
  };

  return (
    <View style={styles.containerStyle}>
      <View style={titleContainerStyle}>
        <VFText
          i18nKey={'soho_plans_plan_users_title'}
          style={titleTextStyle}
          testKey={SohoFrameworkTestKeys.PlanUsersTitle}
        />
      </View>
      {renderUserCards(users)}
    </View>
  );
}

Users.defaultProps = {
  withRemoveUser: true,
};

Users.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      name: PropTypes.string,
      '@type': PropTypes.string,
      '@referredType': PropTypes.string,
    }),
  ),
  onRemoveUserPress: PropTypes.func,
  onViewProfilePress: PropTypes.func,
  images: PropTypes.object,
  titleContainerStyle: ViewPropTypes.style,
  titleTextStyle: TextPropTypes.style,
  userCardContainerStyle: ViewPropTypes.style,
  removeUserIconStyle: Icon.propTypes.style,
  removeUserTextStyle: TextPropTypes.style,
  removeUserContainerStyle: ViewPropTypes.style,
  userIconStyle: Icon.propTypes.style,
  withRemoveUser: PropTypes.bool,
};

export default Users;
